<template>
  <b-row class="mb-1">
    <b-col :md="resultCount !== null ? '6' : '12'">
      <div class="permission-search-wrapper">
        <feather-icon
          icon="SearchIcon"
          size="18"
          class="permission-search-icon"
        />
        <input
          :value="value"
          type="text"
          class="form-control permission-search-input"
          :placeholder="placeholder"
          @input="$emit('input', $event.target.value)"
        >
        <button
          v-if="value"
          type="button"
          class="permission-search-clear"
          @click="$emit('input', '')"
        >
          <feather-icon
            icon="XIcon"
            size="16"
          />
        </button>
      </div>
    </b-col>
    <b-col
      v-if="value && resultCount !== null"
      md="6"
      class="d-flex align-items-center"
    >
      <small class="text-muted">
        {{ resultCount }} {{ $t('groups found') }}
      </small>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  name: 'PermissionSearch',
  components: {
    BRow,
    BCol,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search permissions...',
    },
    resultCount: {
      type: Number,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.permission-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.permission-search-icon {
  position: absolute;
  left: 12px;
  color: #999;
  pointer-events: none;
  z-index: 2;
}

.permission-search-input {
  padding-left: 38px !important;
  padding-right: 36px !important;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 2px color-mix(in srgb, var(--primary) 20%, transparent);
  }
}

.permission-search-clear {
  position: absolute;
  right: 8px;
  width: 24px;
  height: 24px;
  border: none;
  background: #e9ecef;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;
  z-index: 2;

  &:hover {
    background: #dee2e6;
    color: #333;
  }
}

.dark-layout {
  .permission-search-clear {
    background: #3b4253;
    color: #b4b7bd;

    &:hover {
      background: #4b4f5e;
      color: #fff;
    }
  }
}
</style>
